"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringifyAndParseObjectsHook = exports.StringifyObjectsHook = void 0;
exports.StringifyObjectsHook = {
    run(event) {
        for (let i = 0; i < event.argumentArray.length; i++) {
            if (event.argumentArray[i] != null && typeof event.argumentArray[i] === 'object') {
                event.argumentArray[i] = JSON.stringify(event.argumentArray[i]);
            }
        }
    }
};
exports.StringifyAndParseObjectsHook = {
    run(event) {
        for (let i = 0; i < event.argumentArray.length; i++) {
            if (event.argumentArray[i] != null && typeof event.argumentArray[i] === 'object') {
                event.argumentArray[i] = JSON.parse(JSON.stringify(event.argumentArray[i]));
            }
        }
    }
};
//# sourceMappingURL=hooks.js.map